/**
 * Product Info Carousel — critical interactions (defer)
 */
(function () {
  'use strict';

  function getCarouselConfig() {
    const el = document.getElementById('product-info-carousel-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function loadCarouselData() {
    const config = getCarouselConfig();
    return {
      variants: config.variants || [],
      colorOptionPosition: config.colorOptionPosition != null ? config.colorOptionPosition : null,
    };
  }

  function loadScriptOnce(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector('script[data-pic-coupon-modal="true"]')) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset.picCouponModal = 'true';
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initCouponModalTrigger() {
    const viewOffersBtn = document.getElementById('view-all-offers-btn');
    if (!viewOffersBtn || viewOffersBtn.dataset.couponTriggerBound === 'true') return;
    viewOffersBtn.dataset.couponTriggerBound = 'true';

    viewOffersBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const config = getCarouselConfig();
      const src = config.assets && config.assets.couponModal;
      loadScriptOnce(src)
        .then(function () {
          if (typeof window.__picInitCouponModal === 'function') {
            window.__picInitCouponModal();
          }
          const couponModal = document.getElementById('coupon-modal');
          if (couponModal) {
            couponModal.classList.add('is-open');
            document.body.classList.add('bb-scroll-lock');
          }
        })
        .catch(function () {});
    });
  }

﻿  // Optimized carousel state management
  let carouselState = {
    currentThumbnailIndex: 0,
    currentThumbnailPage: 0,
    visibleThumbnails: [],
    thumbnailsPerPage: getThumbnailsPerPage(),
    currentColorFilter: null,
    allProductImages: [],
    productVariants: [],
    colorOptionPosition: null,
    cachedElements: {},
    resizeTimeout: null
  };

  const carouselRoot = document.querySelector('.product-info-carousel');
  const carouselGuardTarget = carouselRoot || document.documentElement;

  function getThumbnailsPerPage() {
    return window.innerWidth >= 990 ? 6 : 4;
  }

  function hideFilteredThumbnail(element) {
    element.classList.add('product-info-carousel__thumbnail--filtered-out');
  }

  function showFilteredThumbnail(element) {
    element.classList.remove('product-info-carousel__thumbnail--filtered-out');
  }

  const themeRequestIdleCallback = window.requestIdleCallback || function (callback) {
    return setTimeout(() => callback({
      didTimeout: false,
      timeRemaining: () => 0
    }), 1);
  };
  
  // Debounced resize handler - only updates on breakpoint change
  function handleResize() {
    clearTimeout(carouselState.resizeTimeout);
    carouselState.resizeTimeout = setTimeout(() => {
      const newPerPage = getThumbnailsPerPage();
      if (newPerPage !== carouselState.thumbnailsPerPage) {
        carouselState.thumbnailsPerPage = newPerPage;
        carouselState.currentThumbnailPage = 0;
        updateThumbnailDisplay();
        updateThumbnailNavButtons();
      }
    }, 200); // 200ms debounce
  }
  
  window.addEventListener('resize', handleResize);

  // Initialize product data â€” thumbnails and variants read synchronously so
  // clicks work immediately; only the swatch reorder visual is deferred.
  function initializeProductData() {
    // Read thumbnails synchronously â€” must be ready before any click
    const thumbnails = document.querySelectorAll('.product-info-carousel__thumbnail');
    carouselState.allProductImages = Array.from(thumbnails).map(t => ({
      element: t,
      imageId: t.dataset.imageId,
      index: parseInt(t.dataset.imageIndex)
    }));

    // visibleThumbnails must also be set synchronously so updateThumbnailDisplay
    // and selectThumbnail work before the idle callback fires
    carouselState.visibleThumbnails = carouselState.allProductImages.slice();
    const carouselData = loadCarouselData();
    carouselState.productVariants = carouselData.variants || [];
    carouselState.colorOptionPosition = carouselData.colorOptionPosition;

    // Show all thumbnails initially so the grid is visible before idle fires
    updateThumbnailDisplay();

    // Defer only the visual swatch reorder â€” data is already ready above
    themeRequestIdleCallback(() => {
      const swatches = Array.from(document.querySelectorAll('.product-info-carousel__color-swatch'));
      const availableSwatches = swatches.filter(s => s.dataset.available === 'true');
      const swatchContainer = document.getElementById('color-swatches');

      if (swatchContainer && availableSwatches.length > 0) {
        swatches.forEach(s => s.classList.remove('product-info-carousel__color-swatch--active'));
        availableSwatches.forEach(s => swatchContainer.appendChild(s));
        swatches.filter(s => s.dataset.available !== 'true').forEach(s => swatchContainer.appendChild(s));
      }

      if (availableSwatches.length > 0) {
        const firstAvailable = availableSwatches[0];
        const {colorName, colorVariantIds, colorImageSrcs} = firstAvailable.dataset;
        if (colorName) {
          firstAvailable.classList.add('product-info-carousel__color-swatch--active');
          selectColor(colorName, true, colorVariantIds, colorImageSrcs);
        }
      } else {
        carouselState.visibleThumbnails = carouselState.allProductImages.slice();
        updateThumbnailDisplay();
        if (carouselState.allProductImages.length > 0) {
          selectThumbnail(carouselState.allProductImages[0].index);
        }

        const variantInput = document.getElementById('product-variant-id');
        let initialAvailable = true;
        if (variantInput && carouselState.productVariants.length > 0) {
          const selectedVariant = carouselState.productVariants.find(v => String(v.id) === String(variantInput.value));
          if (selectedVariant) {
            initialAvailable = !!selectedVariant.available;
          }
        }
        updateButtonStates(initialAvailable);
      }
    }, { timeout: 500 });
  }

  function filterThumbnailsByColor(colorName, colorVariantIdsStr, colorImageSrcsStr) {
    carouselState.currentColorFilter = colorName;
    const mainImage = document.getElementById('product-main-image');
    if (carouselState.allProductImages.length === 0) return;

    let filteredThumbnails = [];
    const colorNameLower = colorName ? colorName.toLowerCase().trim() : '';
    const variantIdSet = new Set((colorVariantIdsStr || '').split(',').filter(Boolean).map(s => s.trim()));
    const imageSrcSet = new Set((colorImageSrcsStr || '').split('|||').filter(Boolean).map(s => s.trim()));
    
    // Single pass through all images with multiple matching methods
    filteredThumbnails = carouselState.allProductImages.filter(img => {
      const thumbnail = img.element;
      const imageAlt = (thumbnail.dataset.imageAlt || '').toLowerCase();
      const variantIds = (thumbnail.dataset.variantIds || '').split(',').map(s => s.trim());
      const imageSrc = thumbnail.dataset.imageSrc || '';
      
      return (colorNameLower && imageAlt.includes(colorNameLower)) ||
             variantIds.some(vid => variantIdSet.has(vid)) ||
             imageSrcSet.has(imageSrc);
    });
    
    // Fallback: If no matches, show all images
    if (filteredThumbnails.length === 0) {
      filteredThumbnails = carouselState.allProductImages;
    }

    // Batch update â€” collapse filtered thumbs horizontally, keep row height stable
    requestAnimationFrame(() => {
      carouselState.allProductImages.forEach(img => hideFilteredThumbnail(img.element));
      carouselState.visibleThumbnails = filteredThumbnails;
      carouselState.currentThumbnailPage = 0;
      updateThumbnailDisplay();
      
      if (filteredThumbnails.length > 0 && mainImage) {
        const firstThumbnail = filteredThumbnails[0].element;
        const img = firstThumbnail.querySelector('img');
        if (img && img.dataset.fullImage) {
          // Remove the picture element's source to prevent conflicts
          const picture = mainImage.closest('picture');
          if (picture) {
            const sources = picture.querySelectorAll('source');
            sources.forEach(source => source.remove());
          }
          
          // Force image reload by clearing and setting src
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = '';
          
          // Use requestAnimationFrame to ensure the clear happens before setting new src
          requestAnimationFrame(() => {
            mainImage.src = img.dataset.fullImage;
            mainImage.alt = img.alt || '';
          });
          
          document.querySelectorAll('.product-info-carousel__thumbnail').forEach(t => t.classList.remove('active'));
          firstThumbnail.classList.add('active');
          showFilteredThumbnail(firstThumbnail);
        }
      }
    });
  }

  function updateThumbnailDisplay() {
    // Show visible thumbnails â€” CSS handles scroll with fade hint
    carouselState.allProductImages.forEach((img) => hideFilteredThumbnail(img.element));
    carouselState.visibleThumbnails.forEach((img) => showFilteredThumbnail(img.element));
    updateThumbnailNavButtons();
  }

  function selectThumbnail(index) {
    const mainImage = document.getElementById('product-main-image');
    const selectedImage = carouselState.allProductImages.find(img => img.index === index);
    const selectedThumbnail = selectedImage ? selectedImage.element : null;
    
    if (!selectedThumbnail || !mainImage) {
      return;
    }

    carouselState.allProductImages.forEach(img => img.element.classList.remove('active'));
    selectedThumbnail.classList.add('active');
    
    const img = selectedThumbnail.querySelector('img');
    
    if (img && img.dataset.fullImage) {
      const fullSrc = img.dataset.fullImage;
      
      // Remove the picture element's source to prevent conflicts
      const picture = mainImage.closest('picture');
      if (picture) {
        const sources = picture.querySelectorAll('source');
        sources.forEach(source => source.remove());
      }
      
      // Force image reload by clearing and setting src
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = '';
      
      // Use requestAnimationFrame to ensure the clear happens before setting new src
      requestAnimationFrame(() => {
        mainImage.src = fullSrc;
        mainImage.alt = img.alt || '';
      });
    }
  }

  function navigateThumbnails(direction) {
    const container = document.querySelector('.product-info-carousel__thumbnails');
    if (!container) return;
    const scrollAmount = 88 * 2; // scroll 2 thumbnails worth
    container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    // Update nav button states after scroll settles
    setTimeout(updateThumbnailNavButtons, 350);
  }

  function updateThumbnailNavButtons() {
    const container = document.querySelector('.product-info-carousel__thumbnails');
    const prev = document.querySelector('.product-info-carousel__thumbnail-nav--prev');
    const next = document.querySelector('.product-info-carousel__thumbnail-nav--next');
    if (!container) return;
    const atStart = container.scrollLeft <= 4;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 4;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function selectColor(colorName, isAvailable, colorVariantIds, colorImageSrcs) {
    const colorLabel = document.getElementById('selected-color-name');
    const swatches = document.querySelectorAll('.product-info-carousel__color-swatch');
    
    swatches.forEach(s => s.classList.remove('product-info-carousel__color-swatch--active'));
    document.querySelector(`[data-color-name="${colorName}"]`)?.classList.add('product-info-carousel__color-swatch--active');
    
    if (colorLabel) {
      colorLabel.textContent = colorName;
      // Show out of stock indicator in color label
      if (!isAvailable) {
        colorLabel.style.color = '#ef4444'; // Red color for out of stock
      } else {
        colorLabel.style.color = '';
      }
    }
    
    // Update variant input
    const variantInput = document.getElementById('product-variant-id');
    if (variantInput && carouselState.productVariants.length > 0) {
      const matching = carouselState.productVariants.filter(v => {
        const pos = carouselState.colorOptionPosition;
        return (pos === 1 && v.option1 === colorName) || (pos === 2 && v.option2 === colorName) || (pos === 3 && v.option3 === colorName);
      });
      const selected = matching.find(v => v.available) || matching[0];
      if (selected) variantInput.value = selected.id;
    }
    
    // Update button states based on availability
    updateButtonStates(isAvailable);
    
    filterThumbnailsByColor(colorName, colorVariantIds || '', colorImageSrcs || '');
  }

  function updateButtonStates(isAvailable) {
    const buyNowBtn = document.querySelector('.product-info-carousel__buy-now');
    const addToCartBtn = document.querySelector('.product-info-carousel__add-to-cart');
    const notifyBtn = document.querySelector('.product-info-carousel__notify-whatsapp');
    
    if (buyNowBtn) {
      if (!isAvailable) {
        buyNowBtn.disabled = true;
        buyNowBtn.style.display = 'none';
        buyNowBtn.style.opacity = '1';
        buyNowBtn.style.cursor = 'pointer';
      } else {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = 'Buy Now';
        buyNowBtn.style.display = '';
        buyNowBtn.style.opacity = '1';
        buyNowBtn.style.cursor = 'pointer';
      }
    }
    
    if (addToCartBtn) {
      if (!isAvailable) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Out of Stock';
        addToCartBtn.style.display = '';
        addToCartBtn.style.opacity = '0.6';
        addToCartBtn.style.cursor = 'not-allowed';
        addToCartBtn.style.pointerEvents = 'none';
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
        addToCartBtn.style.display = '';
        addToCartBtn.style.opacity = '1';
        addToCartBtn.style.cursor = 'pointer';
        addToCartBtn.style.pointerEvents = '';
      }
    }

    if (notifyBtn) {
      notifyBtn.style.display = isAvailable ? 'none' : 'inline-flex';
    }
  }

  function toggleDescription(button) {
    const descriptionText = button.previousElementSibling;
    const isExpanded = descriptionText.classList.contains('expanded');
    
    if (isExpanded) {
      descriptionText.classList.remove('expanded');
      button.textContent = 'See more';
    } else {
      descriptionText.classList.add('expanded');
      button.textContent = 'See less';
    }
  }

  // Global event delegation for all interactive elements
  function handleProductCarouselClick(e) {
    // Handle thumbnail clicks (including clicks on images inside thumbnails)
    let target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__thumbnail')) {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(target.dataset.imageIndex);
        if (!isNaN(index)) {
          selectThumbnail(index);
        }
        return;
      }
      target = target.parentElement;
    }

    // Handle color swatch clicks
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__color-swatch')) {
        e.preventDefault();
        e.stopPropagation();
        const colorName = target.dataset.colorName;
        const isAvailable = target.dataset.available === 'true';
        const colorVariantIds = target.dataset.colorVariantIds || '';
        const colorImageSrcs = target.dataset.colorImageSrcs || '';
        if (colorName) {
          // Allow selection of both available and out-of-stock colors
          selectColor(colorName, isAvailable, colorVariantIds, colorImageSrcs);
        }
        return;
      }
      target = target.parentElement;
    }

    // Handle favorite/wishlist button clicks
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && (target.classList.contains('product-info-carousel__icon-button--favorite') || target.classList.contains('product-info-carousel__icon-button--wishlist'))) {
        e.preventDefault();
        e.stopPropagation();
        target.classList.toggle('active');
        return;
      }
      target = target.parentElement;
    }

    // Handle share button clicks
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__icon-button--share')) {
        e.preventDefault();
        e.stopPropagation();
        if (navigator.share) {
          navigator.share({
            title: document.querySelector('.product-info-carousel__title')?.textContent || 'Product',
            url: window.location.href
          }).catch(() => {
            // Fallback: copy to clipboard
            navigator.clipboard.writeText(window.location.href);
            target.setAttribute('aria-label', 'Link copied!');
            setTimeout(() => {
              target.setAttribute('aria-label', 'Share');
            }, 2000);
          });
        } else {
          // Fallback for browsers without Web Share API
          navigator.clipboard.writeText(window.location.href);
          target.setAttribute('aria-label', 'Link copied!');
          setTimeout(() => {
            target.setAttribute('aria-label', 'Share');
          }, 2000);
        }
        return;
      }
      target = target.parentElement;
    }

    // Handle Add to Cart button (clean up return_to)
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__add-to-cart')) {
        // Allow default submit behavior, but ensure return_to is removed
        const form = document.getElementById('product-form-installment');
        if (form) {
          const returnTo = form.querySelector('input[name="return_to"]');
          if (returnTo) {
            returnTo.remove();
          }
        }
        // Do not return, let the submit event propagate naturally
        break;
      }
      target = target.parentElement;
    }

    // Handle description toggle
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__description-toggle')) {
        e.preventDefault();
        e.stopPropagation();
        toggleDescription(target);
        return;
      }
      target = target.parentElement;
    }

    // Handle copy coupon button
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__copy-button')) {
        e.preventDefault();
        e.stopPropagation();
        const code = target.dataset.couponCode || 'WELCOME';
        navigator.clipboard.writeText(code);
        target.textContent = 'Copied!';
        setTimeout(() => {
          target.textContent = 'Copy Code';
        }, 2000);
        return;
      }
      target = target.parentElement;
    }

    // Handle thumbnail navigation buttons
    target = e.target;
    while (target && target !== document.body) {
      if (target.classList && target.classList.contains('product-info-carousel__thumbnail-nav')) {
        e.preventDefault();
        e.stopPropagation();
        const direction = parseInt(target.dataset.navDirection);
        if (!isNaN(direction)) {
          navigateThumbnails(direction);
        }
        return;
      }
      target = target.parentElement;
    }
  }

  // Attach event listener - OPTIMIZED: prevent duplicate handlers
  if (carouselGuardTarget.dataset.carouselClickHandlerAttached !== 'true') {
    document.addEventListener('click', handleProductCarouselClick, true);
    carouselGuardTarget.dataset.carouselClickHandlerAttached = 'true';
  }

  if (carouselGuardTarget.dataset.carouselInitialized !== 'true') {
    const init = () => {
      initializeProductData();

      const thumbContainer = document.querySelector('.product-info-carousel__thumbnails');
      if (thumbContainer) {
        thumbContainer.addEventListener('scroll', updateThumbnailNavButtons, { passive: true });
      }

      initCouponModalTrigger();
    };

    init();
    carouselGuardTarget.dataset.carouselInitialized = 'true';
  }

  window.carouselState = carouselState;
  window.selectThumbnail = selectThumbnail;
})();
